import { render, staticRenderFns } from "./mp.vue?vue&type=template&id=44b3a1ba&scoped=true&"
import script from "./mp.vue?vue&type=script&lang=js&"
export * from "./mp.vue?vue&type=script&lang=js&"
import style0 from "./mp.vue?vue&type=style&index=0&id=44b3a1ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b3a1ba",
  null
  
)

export default component.exports